{
  "fr": {
    "tenant": {
      "actions": {
        "changeCompanyLogo": "Changer le logo (png requis)",
        "changeThemeColor": "Choisir une nouvelle couleur de thème"
      },
      "labels": {
        "customerThemeColor": "Couleur du thème du client",
        "customerThemeColorExlainer": "Cette couleur sera utilisée pour le portail client. Pour le voir à l'œuvre, il suffit d'imiter l'identité d'un client.",
        "logo": "Logo"
      },
      "picture_logo_format": {
        "round": "Logo rond",
        "square": "Logo carré"
      }
    }
  }
}
